import React, { createContext } from 'react';
import { useIntl } from 'react-intl';

import { EntityPageContractType } from '@xing-com/crate-common-graphql-types';
import { usePageContext } from '@xing-com/crate-entity-pages-common';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

type HeaderContextValues = {
  title: string;
  subtitle: string;
  isSubpage?: boolean;
  hasTertiaryArea: boolean;
};
export const HeaderContext = createContext<HeaderContextValues | undefined>(
  undefined
);

type HeaderContextProps = {
  children:
    | React.ReactNode
    | ((context: HeaderContextValues) => React.ReactNode);
  moduleType?: string;
};
export const HeaderContextProvider: React.FC<HeaderContextProps> = ({
  moduleType,
  children,
}) => {
  const { $t } = useIntl();
  const { isLoggedIn } = useLoginState();
  const { pageContext } = usePageContext();

  const isEBP = pageContext.contractType === EntityPageContractType.Paid;
  const isSubpage = !!moduleType;

  let title = pageContext.pageTitle;
  if (isSubpage && moduleType) {
    title = $t({ id: `EP_${moduleType.toUpperCase()}_DESCRIPTION` });
  }

  let subtitle = isEBP ? pageContext.pageSlogan : '';
  if (isSubpage || !pageContext.pageSlogan) {
    subtitle = pageContext.pageTitle;
  }

  const socialProofTotal = pageContext.socialProof?.total || 0;
  const hasSomeSocialProof = socialProofTotal > 0;

  const hasTertiaryArea = isLoggedIn && !isSubpage && hasSomeSocialProof;

  return (
    <HeaderContext.Provider
      value={{ title, subtitle, isSubpage, hasTertiaryArea }}
    >
      {typeof children === 'function'
        ? children({ title, subtitle, isSubpage, hasTertiaryArea })
        : children}
    </HeaderContext.Provider>
  );
};
